export default __webpack_public_path__ + "727536da342cc31e7d232e72470784e7.jpg";